import { render, staticRenderFns } from "./form-input-decimal.vue?vue&type=template&id=92967e98"
import script from "./form-input-decimal.vue?vue&type=script&lang=js"
export * from "./form-input-decimal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports